import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { LwFormAutocomplete } from 'redesign';
import { useState } from 'react';
import { RenderUnsettledUI } from 'shared/components';
import { useDebounce } from 'shared/hooks/use-debounce';
import {
  type FlexpoolType,
  useGetAvailableFlexWorkersForPool,
} from '../hooks/use-get-available-flex-workers-for-pool';

type AddFlexWorkerToPoolProps = {
  flexpoolType: FlexpoolType;
  poolId: string;
};

export const FlexPoolAddFlexWorker = ({ flexpoolType, poolId }: AddFlexWorkerToPoolProps) => {
  const { t } = useTranslation('ogp-screen-specific');
  const { control, setValue } = useFormContext<{
    flexWorker: { id: string; email: string };
  }>();

  const [input, setSelected] = useState<string>('');
  const debouncedInput = useDebounce(input, 300);

  const { data, isFetching, status, refetch, error } = useGetAvailableFlexWorkersForPool(
    flexpoolType,
    poolId,
    debouncedInput
  );

  if (status === 'error') {
    return <RenderUnsettledUI data={{ status, error, refetch }} />;
  }

  return (
    <Box>
      <LwFormAutocomplete
        name="flexWorker"
        label={t('flexpools.worker_autocomplete_label')}
        getOptionLabel={(option) => option?.email ?? ''}
        getOptionKey={(option) => option.id ?? ''}
        isOptionEqualToValue={(option, value) => {
          return option?.id === value?.id;
        }}
        options={data ?? []}
        isLoading={isFetching}
        control={control}
        rules={{ required: true }}
        onChange={(_event, value) => {
          if (value) {
            setValue('flexWorker', value);
          }
        }}
        onInputChange={(_e, value) => {
          setSelected(value);
        }}
      />
    </Box>
  );
};
